import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

export interface UiResourceSummaryVariantItem {
  id: string;
  name: string;
  quantity?: number;
  unit?: string;
  sellingPrice?: number | null;
}

export interface UiResourceSummaryProductItem {
  id: string;
  name: string;
  variants: UiResourceSummaryVariantItem[];
}

export interface UiResourceSummaryCategoryItem {
  id: string;
  name: string;
  products: UiResourceSummaryProductItem[];
}

@Component({
  selector: 'ui-resource-summary',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-resource-summary.component.html',
  styleUrl: './ui-resource-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiResourceSummaryComponent {
  readonly items = input<UiResourceSummaryCategoryItem[]>([]);
  readonly expandedProductIds = signal<string[]>([]);

  toggleProduct(productKey: string): void {
    this.expandedProductIds.update((ids) => (
      ids.includes(productKey)
        ? ids.filter((id) => id !== productKey)
        : [...ids, productKey]
    ));
  }

  isExpanded(productKey: string): boolean {
    return this.expandedProductIds().includes(productKey);
  }

  productKey(categoryId: string, productId: string): string {
    return `${categoryId}:${productId}`;
  }

  formatQuantity(variant: UiResourceSummaryVariantItem): string {
    const quantity = Number(variant.quantity ?? 0).toLocaleString();
    const unit = variant.unit?.trim();
    return unit ? `${quantity} ${unit}` : quantity;
  }

  formatSellingPrice(value: number | null | undefined): string {
    return value === undefined || value === null ? '—' : Number(value).toLocaleString();
  }
}
